import { API_DECLARE_INTEREST_URL, API_DECLARE_INTEREST_MODAL_URL } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";

interface ICountry {
    label: string;
    value: string;
}

export interface IDeclareInterestResponse {
    data: {
        countries: ICountry[];
    };
    dict: {
        headline: string;
        description: string;
        sendButton: string;
    };
}

export function useDeclareInterestQuery(options: IQueryOptions<IDeclareInterestResponse>) {
    return useQuery<IDeclareInterestResponse>({ url: API_DECLARE_INTEREST_MODAL_URL, ...options });
}

interface IMutationRequest {
    wikifolioId: string;
    email: string;
    country: string;
}

interface IMutationResponse {
    message: string;
}

export interface IDeclareInterestMutationError {
    [fieldName: string]: string;
}

export const useDeclareInterestMutation = () => {
    const { mutatePromise } = useMutation<IMutationResponse, IDeclareInterestMutationError, IMutationRequest>(API_DECLARE_INTEREST_URL);
    return mutatePromise;
};
